var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 0.75H2.125C1.07031 0.75 0.25 1.60938 0.25 2.625V16.375C0.25 17.4297 1.07031 18.25 2.125 18.25H15.875C16.8906 18.25 17.75 17.4297 17.75 16.375V2.625C17.75 1.60938 16.8906 0.75 15.875 0.75ZM14.625 10.5938C14.625 10.8672 14.3906 11.0625 14.1562 11.0625H10.5625V14.6562C10.5625 14.9297 10.3281 15.125 10.0938 15.125H7.90625C7.63281 15.125 7.4375 14.9297 7.4375 14.6562V11.0625H3.84375C3.57031 11.0625 3.375 10.8672 3.375 10.5938V8.40625C3.375 8.17188 3.57031 7.9375 3.84375 7.9375H7.4375V4.34375C7.4375 4.10938 7.63281 3.875 7.90625 3.875H10.0938C10.3281 3.875 10.5625 4.10938 10.5625 4.34375V7.9375H14.1562C14.3906 7.9375 14.625 8.17188 14.625 8.40625V10.5938Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.4da7317ffd3558a77dddf205b36bb72a.svg";
export { ForwardRef as ReactComponent };